"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
function ShadowManagerFactory(pagesManager, pageLayout) {
    return {
        showWidgetShadows: showWidgetShadows,
        showWidgetShadow: showWidgetShadow,
        hideWidgetShadows: hideWidgetShadows,
        hideWidgetShadow: hideWidgetShadow
    };
    function showWidgetShadows(widgets) {
        lodash_1.default.forEach(widgets, showWidgetShadow);
    }
    function hideWidgetShadows(widgets) {
        lodash_1.default.forEach(widgets, hideWidgetShadow);
    }
    function showWidgetShadow(widget) {
        if (widget.chunks) {
            lodash_1.default.forEach(widget.chunks, showWidgetShadow);
            return;
        }
        // we need to re-attach the same shadow object so it animates, so we keep track of it here
        var shadow = widget.shadow || {};
        hideWidgetShadow(widget);
        widget.shadow = angular_1.extend(shadow, widget.layout);
        // we use the row because we aren't updating the page on the parent widget just yet
        // @ts-ignore
        widget.shadow.page = Math.floor(widget.layout.row / pageLayout.getRows());
        pagesManager.addShadow(widget.shadow);
    }
    function hideWidgetShadow(widget) {
        if (widget.chunks) {
            lodash_1.default.forEach(widget.chunks, hideWidgetShadow);
            return;
        }
        if (!widget.hasOwnProperty('shadow')) {
            return;
        }
        pagesManager.removeShadow(widget.shadow);
        delete widget.shadow;
    }
}
(function (angularModule) {
    angularModule.factory('pr.shadowManager', [
        'pr.uiPagesManager',
        'prPageLayoutService',
        ShadowManagerFactory
    ]);
})(angular_1.module('qualtrics.pr'));
